import { forwardHubbleEventsIntoTealium } from "./hubble.js";
import queue_default from "./queue.js";

//#region src/adapter.ts
const makeTealiumAdapter = (options = {}) => {
	const { maxQueueSize = 200 } = options;
	const initialise = () => {
		if (typeof window !== "undefined") {
			window.utag_data = {};
			window.utag_cfg_ovrd = { noview: true };
		}
	};
	const { size, dequeueAll, enqueue } = queue_default({ max: maxQueueSize });
	const track = (type, props) => {
		if (typeof window === "undefined") return;
		if (window.SEEK_TEST === true) return;
		if (window.ANALYTICS_DEBUG) console.log({
			adapter: "tealium",
			type,
			props
		});
		const { utag } = window;
		if (typeof utag !== "undefined" && typeof utag.track === "function") setTimeout(() => {
			utag.track(type, { ...props });
		});
		else {
			enqueue({
				type,
				props
			});
			setQueueTimer();
		}
	};
	const setQueueTimer = () => {
		if (size() === 1) {
			const utagReady = setInterval(() => {
				const { utag } = window;
				if (typeof utag !== "undefined" && typeof utag.track === "function") {
					clearInterval(utagReady);
					dequeueAll(({ type: eventType, props: eventProps }) => setTimeout(() => {
						utag.track(eventType, eventProps);
					}));
				}
			}, 200);
		}
	};
	const link = (eventName, { linkName,...props } = {}) => track("link", {
		eventName,
		linkName: linkName ?? eventName,
		...props
	});
	const view = (eventName, props = {}) => track("view", {
		eventName,
		...props
	});
	initialise();
	if (options.hubble) forwardHubbleEventsIntoTealium(options.hubble, track);
	return {
		link,
		view
	};
};
var adapter_default = makeTealiumAdapter;

//#endregion
export { adapter_default as default };
//# sourceMappingURL=adapter.js.map